import * as Yup from 'yup';
import { SarlaftTypePerson } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftTypePerson = {
    typePerson: '',
};

export const validationSchema = Yup.object({
    typePerson: Yup.string().required('El tipo de persona obligatorio'),
});
